import React, { useState } from "react";
import { Avatar } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const Promotion = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const data = [
    {
      key: "1",
      name: "Antony",
      department: "Finance",
      from: "Accountant",
      to: "Sr Accountant",
      date: "14 Jan 2024",
    },
    {
      key: "2",
      name: "Antony",
      department: "Finance",
      from: "Jr App Developer",
      to: "Sr App Developer",
      date: "14 Jan 2024",
    },
    {
      key: "3",
      name: "Antony",
      department: "Finance",
      from: "Sr Web Developer",
      to: "Team Lead",
      date: "14 Jan 2024",
    },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: "",
      render: () => <input type="checkbox" />,
      width: 50,
    },
    {
      title: "Promoted Employee",
      dataIndex: "name",
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Avatar src="https://i.pravatar.cc/40" />
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Department",
      dataIndex: "department",
    },
    {
      title: "Designation From",
      dataIndex: "from",
    },
    {
      title: "Designation To",
      dataIndex: "to",
    },
    {
      title: "Promotion Date",
      dataIndex: "date",
    },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Promotion List"
      columns={columns}
      data={filteredData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearchText}
    />
  );
};

export default Promotion;